import 'slick-carousel';

jQuery(document).ready(function($) {
    /**
     * JS 相册
     */
    const slider = $('.js-galleries');

    const leftIcon = '<svg xmlns="http://www.w3.org/2000/svg" width="12" height="32" viewBox="0 0 12 32"><path d="M1.569 15.469l7.363-7.25c0.294-0.294 0.769-0.294 1.063 0l0.444 0.444c0.294 0.294 0.294 0.769 0 1.063l-6.394 6.275 6.388 6.275c0.294 0.294 0.294 0.769 0 1.063l-0.444 0.444c-0.294 0.294-0.769 0.294-1.063 0l-7.362-7.25c-0.288-0.294-0.288-0.769 0.006-1.063z"></path></svg>';
    const rightIcon = '<svg xmlns="http://www.w3.org/2000/svg" width="12" height="32" viewBox="0 0 12 32"><path d="M10.431 16.531l-7.362 7.25c-0.294 0.294-0.769 0.294-1.063 0l-0.444-0.444c-0.294-0.294-0.294-0.769 0-1.063l6.394-6.275-6.388-6.275c-0.294-0.294-0.294-0.769 0-1.063l0.444-0.444c0.294-0.294 0.769-0.294 1.063 0l7.362 7.25c0.287 0.294 0.287 0.769-0.006 1.063z"></path></svg>';

    if (slider.length) {
        slider.each(function() {
            const current_slider = $(this);
            const current_gallery = current_slider.closest('.o-gallery');
            const current_nav = current_gallery.find('.js-galleries__nav');

            if (current_slider.hasClass('slick-initialized') || ! current_nav.length || current_nav.hasClass('slick-initialized')) {
                return;
            }

            current_slider.slick({
                slidesToShow  : 1,
                slidesToScroll: 1,
                arrows        : false,
                infinite      : false,
                fade          : false,
                asNavFor      : current_nav,
            });

            current_nav.slick({
                slidesToShow  : 3,
                slidesToScroll: 1,
                asNavFor      : current_slider,
                dots          : false,
                infinite      : false,
                //centerMode    : true,
                focusOnSelect: true,
                prevArrow: '<button type="button" class="slick-prev" aria-label="Previous"> ' + leftIcon + '</button>',
                nextArrow: '<button type="button" class="slick-next" aria-label="Next">' + rightIcon + '</button>',
            });
        });
    }
});
